export const palette = {
  mode: "dark",

  background: {
    default: "#000000",
    paper: "#424242",
  },

  text: {
    primary: "#ffffff",
  },

  primary: {
    main: "#5221e6",
    light: "#744deb",
    dark: "#3917A1",
    contrastText: "#ffffff",
  },

  secondary: {
    main: "#181823",
    light: "#46464F",
    dark: "#101018",
    contrastText: "#ffffff",
  },

  info: {
    main: "#2196f3",
    light: "#64b5f6",
    dark: "#1976d2",
    contrastText: "#ffffff",
  },

  success: {
    main: "#4caf50",
    light: "#81c784",
    dark: "#388e3c",
    contrastText: "#000000de",
  },

  warning: {
    main: "#ff9800",
    light: "#ffb74d",
    dark: "#f57c00",
    contrastText: "#000000de",
  },

  error: {
    main: "#f44336",
    light: "#e57373",
    dark: "#d32f2f",
    contrastText: "#ffffff",
  },

  divider: "#ffffff1f",
};
